export default __webpack_public_path__ + "static/media/42_4_1.53b1d008.png";